// extracted by mini-css-extract-plugin
module.exports = {"content":"AddCourse_content__2MIaD","submitButton":"AddCourse_submitButton__Toai9","tiny":"AddCourse_tiny__3JzcK","header":"AddCourse_header__1dxMk","card":"AddCourse_card__2rEb6"};